import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setSearchOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页', icon: 'ri-home-3-line' },
    { path: '/category/hanman', label: '分类', icon: 'ri-grid-line' },
    { path: '/about', label: '关于我们', icon: 'ri-information-line' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60' : 'bg-transparent'}`}>
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-read-line text-lg text-background-50"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950 group-hover:text-primary-500 transition-colors">土豪漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            {searchOpen ? (
              <div className="flex items-center bg-background-100 rounded-lg px-3 py-2 gap-2 animate-[fadeIn_0.2s_ease]">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索漫画..."
                  className="bg-transparent text-sm text-foreground-950 placeholder-foreground-400 outline-none w-48"
                  autoFocus
                  onBlur={() => { if (!searchQuery) setSearchOpen(false); }}
                  onKeyDown={(e) => { if (e.key === 'Escape') { setSearchOpen(false); setSearchQuery(''); } }}
                />
                {searchQuery && (
                  <button onClick={() => setSearchQuery('')} className="w-5 h-5 flex items-center justify-center cursor-pointer">
                    <i className="ri-close-line text-foreground-400 text-xs"></i>
                  </button>
                )}
              </div>
            ) : (
              <button
                onClick={() => setSearchOpen(true)}
                className="w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
              >
                <i className="ri-search-line text-foreground-600 text-lg"></i>
              </button>
            )}
            <Link
              to="/about"
              className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
            >
              <i className={`${searchOpen ? 'ri-close-line' : 'ri-search-line'} text-foreground-600 text-lg`}></i>
            </button>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-600 text-xl`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="md:hidden pb-3 animate-[fadeIn_0.2s_ease]">
            <div className="flex items-center bg-background-100 rounded-lg px-3 py-2 gap-2">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="bg-transparent text-sm text-foreground-950 placeholder-foreground-400 outline-none flex-1"
                autoFocus
              />
            </div>
          </div>
        )}
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 animate-[fadeIn_0.2s_ease]">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <i className={`${link.icon} text-base`}></i>
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm bg-primary-500 text-background-50 font-medium"
            >
              <i className="ri-information-line text-base"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}